import React from 'react';

import useStyles from './VisuallyHidden.style';

interface VisuallyHiddenProps {
  forceShow?: boolean;
  children: React.ReactElement | string;
  id?: string;
  component?: React.ElementType;
}

export const VisuallyHidden: React.FC<VisuallyHiddenProps> = ({ children, forceShow, id, component: Component = 'span', ...restProps }) => {
  const c = useStyles({});

  if (forceShow) {
    return <Component id={id} {...restProps}>{children}</Component>;
  }
  return (
    <Component className={c.root} id={id} {...restProps}>
      {children}
    </Component>
  );
};
